import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  headerSection: {
    marginBottom: 50,
    marginTop: 10,
  },
  header: {
    width: '100%',
    height: '100%',
    padding: '10px 0',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      padding: '20px 0 30px 0',
    },
  },
  appTitle: {
    fontSize: '2.8625em',
    color: theme.palette.primary.main,
    paddingBottom: 0,
    marginBottom: 10,
    maxWidth: '75%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
    },
  },
  linkQlik: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: -30,
    right: 0,
    color: '#16A054',
    fontWeight: 600,
    [theme.breakpoints.down('xs')]: {
      fontSize: '.95rem',
      flexDirection: 'column',
      textAlign: 'right',
      top: -30,
      right: 0,
    },
  },
  linkQlikText: {
    paddingRight: 5,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  logoQlikAnalytics: {
    width: 240,
    height: 'auto',
    '@media (max-width: 768px)': {
      width: 180,
    },
  },
  link: {
    fontSize: '1.2rem',
    paddingRight: 10,
    textDecoration: 'none',
    textTransform: 'uppercase',
    color: '#404040',
    transition: 'color 0.3s ease-in-out',
    '&:hover': {
      color: '#CF1F38 !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem',
    },
  },
  navigation: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '20px',
    marginTop: 10,
    flexWrap: 'wrap',
  },
}));

export default useStyles;
